export const downloadFile = (data: any, name: string, fileType: string) => {
    let url: string;
    let blob: Blob;

    if (fileType === "json") {
        blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    } else if (fileType === "zip") {
        // Für ZIP-Dateien: korrekter MIME-Type und direkte Blob-Erstellung
        blob = new Blob([data], { type: "application/zip" });
    } else {
        // Für andere binäre Dateien
        blob = new Blob([data], { type: "application/octet-stream" });
    }

    url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}_${new Date().toISOString()}.${fileType}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup: URL freigeben
    window.URL.revokeObjectURL(url);
}
